import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import { additionalPolicyMeta } from "./AdditionalPolicy";
import "../css/privacy.scss";
import "../css/policies.scss";

const corePolicies = [
  { label: "Privacy policy", path: "/privacy", category: "Privacy", description: "How personal information is collected, used, shared, retained and protected." },
  { label: "Cookie policy", path: "/cookies", category: "Privacy", description: "Essential browser storage, limited performance data and browser controls." },
  { label: "Terms & conditions", path: "/terms", category: "Legal", description: "The agreement governing use of the store and purchases." },
  { label: "Shipping policy", path: "/shipping", category: "Orders", description: "Processing, tracked delivery, destinations, delays and missing parcels." },
  { label: "Returns & refunds", path: "/returns", category: "Orders", description: "Eligibility, return steps, refunds, damaged items and exchanges." },
];

const additionalCategories = {
  payments: "Orders",
  orders: "Orders",
  "product-safety": "Product care",
  "quality-guarantee": "Product care",
  promotions: "Orders",
  "data-rights": "Privacy",
  communications: "Privacy",
  security: "Trust & safety",
  accessibility: "Site information",
  "intellectual-property": "Legal",
  sustainability: "Responsible care",
  complaints: "Customer care",
};

const policies = [
  ...corePolicies,
  ...additionalPolicyMeta.map((policy) => ({
    ...policy,
    category: additionalCategories[policy.key],
  })),
];

function Policies() {
  return (
    <main className="privacy policy-page policies-index">
      <header className="policy-page__hero">
        <p className="policy-page__kicker">Customer care & legal</p>
        <h1>Store policies</h1>
        <p>
          Clear information about shopping with {siteConfig.brandName}, from
          payment and delivery to privacy, product care and support.
        </p>
        <span>Last updated {siteConfig.policies.lastUpdated}</span>
      </header>

      <section className="policies-index__intro" aria-labelledby="policy-guide-title">
        <p className="policy-page__kicker">Policy guide</p>
        <h2 id="policy-guide-title">Everything in one place</h2>
        <p>
          Select a policy for full details. These policies work together and do
          not limit consumer or privacy rights that cannot be waived under
          applicable law.
        </p>
      </section>

      <div className="policies-index__grid">
        {policies.map((policy, index) => (
          <Link className="policy-card" to={policy.path} key={policy.path}>
            <span className="policy-card__number">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="policy-card__category">{policy.category}</span>
            <h2>{policy.label}</h2>
            <p>{policy.description}</p>
            <span className="policy-card__action">Read policy <span aria-hidden="true">→</span></span>
          </Link>
        ))}
      </div>

      <section className="policies-index__help" aria-labelledby="policy-help-title">
        <div>
          <p className="policy-page__kicker">Need help?</p>
          <h2 id="policy-help-title">Ask us about an order or policy</h2>
        </div>
        <p>
          Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
          For order questions, include the email used at checkout and your order number,
          but never send full payment-card details.
        </p>
      </section>
    </main>
  );
}

export default Policies;
